<template>
    <div class="kt-portlet">
        <div class="kt-portlet__body" style="color: black; background-color: #fff">
            <h6>{{TitleProfitAmount}}</h6>
            <div class="text-center">
                <h4 class="fix-margin">
                    {{ProfitAmount}}
                    <span  v-if="needCurrency" style="font-size: 1.5rem">
                    {{' ' + $t('currency.rial')}}
                    </span>
                    <span  v-if="needPercent" style="font-size: 1.5rem">
                    {{' ' + $t('marketing.dashboard.percentage')}}
                    </span>
                </h4>
            </div>
            <div class="line-divider mt-4 mb-3"></div>
            <div class="row">
                <div class="col-md-6 col-lg-6 col-sm-6 border-right">
                    <div class="mb-3" style="font-size: 0.82rem">
                        {{TitleBalance}}
                    </div>
                    <div class="text-center">
                        <h4 class="fix-margin">
                            {{Balance}}
                            <span style="font-size: 1.5rem">
                        {{' ' + $t('currency.rial')}}
                        </span>
                        </h4>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-6">
                    <div class="mb-3" style="font-size: 0.82rem">
                        {{TitleSettlement}}
                    </div>
                    <div class="text-center">
                        <h4 class="fix-margin">
                            {{SettlementedAmount}}
                            <span style="font-size: 1.5rem">
                            {{' ' + $t('currency.rial')}}
                            </span>
                        </h4>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    export default {
        name: "",

        props: {
            TitleBalance: {
                default() {
                    return {}
                }
            },
            TitleProfitAmount: {
                default() {
                    return {}
                }
            },
            TitleSettlement: {
                default() {
                    return {}
                }
            },
            Balance: {
                default() {
                    return {}
                }
            },
            ProfitAmount: {
                default() {
                    return {}
                }
            },
            SettlementedAmount: {
                default() {
                    return {}
                }
            },
            needCurrency: {
                default() {
                    return {}
                }
            },
            needPercent: {
                default() {
                    return {}
                }
            }
        },

    }
</script>

<style>

</style>